module.exports = __webpack_public_path__ + "static/32gde-ee97547893a8e2a1b973fb4ed73bbe1a.gif";